export default "__VITE_ASSET__D$sDjgyb__"